import { useEffect, useState } from "react";
import { updateTagsActuLive } from "../../../../../api/index.js";
import { Box, IconButton, TextField, Typography } from "@mui/material";
import { Edit as EditIcon, Delete as DeleteIcon  } from '@mui/icons-material';
import CheckIcon from '@mui/icons-material/Check';
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import useStyles from '../../../../../styles/global-mui.js';
import DsasButton from "../../../../components/DsasButton/DsasButton.js";

const TagsManager = ({ actu }) => {
    const [tags, setTags] = useState(actu.tags || []); // Initialiser les tags avec ceux de l'actu
    const [newTag, setNewTag] = useState('');
    const [editingTagId, setEditingTagId] = useState(null);
    const [editedTagName, setEditedTagName] = useState('');

    useEffect(() => {

        setTags(actu.tags || [])

    }, [actu.tags])

    const onUpdateTags = async (updatedTags) => {
        try {
            console.log("tags sent ", updatedTags)
          const response = await updateTagsActuLive(actu.idActu, updatedTags);
          console.log('Tags mis à jour :', response.data.tags);
        } catch (error) {
          console.error('Erreur lors de la mise à jour des tags', error);
        }
      };
  
    // Fonction pour ajouter un nouveau tag
    const handleAddTag = () => {
      if (newTag.trim() === '') return;
      const newTagObj = { name: newTag }; // Temporairement, utiliser un ID unique localement
      setTags([...tags, newTagObj]);
      setNewTag('');
      onUpdateTags([...tags, newTagObj]); // Propagate change to parent component or server
    };
  
    // Fonction pour modifier un tag
    const handleEditTag = (id) => {
        console.log("Id ", id)
      const updatedTags = tags.map(tag => tag._id === id ? { ...tag, name: editedTagName } : tag);
      setTags(updatedTags);
      setEditingTagId(null);
      setEditedTagName('');
      onUpdateTags(updatedTags); // Propagate change to parent component or server
    };
  
    // Fonction pour démarrer l'édition d'un tag
    const startEditing = (id, currentName) => {
        console.log("Start editing ", id)
      setEditingTagId(id);
      setEditedTagName(currentName);
    };

    // Fonction pour supprimer un tag
    const handleDeleteTag = (id) => {
        const updatedTags = tags.filter((tag) => tag._id !== id);
        setTags(updatedTags);
        onUpdateTags(updatedTags); // Propagate change to parent component or server
    };

    const classes = useStyles();
  
    return (
      <Box sx={{display: 'flex',
    flexDirection: 'row',
    alignContent: 'stretch',
    flexWrap: 'nowrap',
    justifyContent: 'flex-end'}}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, p : 1, m : 2, border:'1px solid #dadada', borderRadius: '8px', width:'fit-content' }}>

      <Typography
      variant="h3"
      sx={{padding:'4px'}}
      > Gestion des tags</Typography>
              
              <Box className='large-separator'></Box>

        {/* Liste des tags existants */}
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {tags.map((tag) => (
            <Box key={tag._id} sx={{ display: 'flex', alignItems: 'center', border: '1px solid gray', borderRadius: '4px', padding: '4px 8px' }}>
              {editingTagId === tag._id ? (
                <TextField
                className={classes.customInput}
                  size="small"
                  value={editedTagName}
                  onChange={(e) => setEditedTagName(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && handleEditTag(tag._id)} // Allow Enter to confirm
                />
              ) : (
                <span>{tag.name}</span>
              )}
              {editingTagId === tag._id ? (
                <IconButton size="small" onClick={() => handleEditTag(tag._id)}>
                  <CheckIcon />
                </IconButton>
              ) : (
                <IconButton size="small" onClick={() => startEditing(tag._id, tag.name)}>
                  <EditIcon />
                </IconButton>
              )}

                <IconButton size="small" onClick={() => handleDeleteTag(tag._id)}>
                <DeleteIcon />
                </IconButton>
            </Box>
          ))}
        </Box>
  
        {/* Ajouter un nouveau tag */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, pb:1 }}>
          <TextField
          className={classes.customInput}
            size="small"
            value={newTag}
            onChange={(e) => setNewTag(e.target.value)}
            placeholder="Créer un tag"
            onKeyDown={(e) => e.key === 'Enter' && handleAddTag()} // Allow Enter to add tag
          />
          <DsasButton icon={faPlus} label="Créer" variant = 'secondary' onClick={handleAddTag} customCss={{margin:0}} />
        </Box>
      </Box>
      </Box>
    );
};

export default TagsManager